export default __webpack_public_path__ + "static/media/alta-2.fa55d13a.png";